




















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { shouldDisplayForTargetBrand, triggerExternalLogin } from '@spa/router/externalLogin'
import ExternalLoginBrandButton from './ExternalLoginBrandButton.vue'

@Component({
  components: {
    ExternalLoginBrandButton,
  },
})
export default class ExternalLogin extends Vue {
  @Prop({ required: true })
  brands: string[]

  @Prop({ required: true })
  redirectEndpoint: string

  @Prop({ default: null })
  brandContext: string | null

  get brandsOnlyExternalLoginEnabled(): string[] {
    return this.brands.filter(shouldDisplayForTargetBrand)
  }

  get classForEachBrandButton(): string[] {
    if (this.someBrandsIsEnabledExternalLogin) {
      return [
        'mb-3',
      ]
    }

    return []
  }

  handleExternalLogin(brand: string) {
    triggerExternalLogin(brand, {
      redirectEndpoint: this.redirectEndpoint,
      brandContext: this.brandContext,
    })
  }

  private get someBrandsIsEnabledExternalLogin(): boolean {
    return this.countOfBrandsExternalLoginEnabled > 1
  }
  private get countOfBrandsExternalLoginEnabled(): number {
    return this.brandsOnlyExternalLoginEnabled.length
  }
}
